import {Column, Entity, ManyToOne, PrimaryGeneratedColumn} from "typeorm";
import {Projeto} from "./Projeto";
import {Especime} from "./Especime";
import {JoinColumn} from "typeorm/browser";
import {Entidade} from "./Entidade";

@Entity("arquivo")
export class Arquivo extends Entidade{
  @Column()
  nome?: string

  @Column()
  caminho?: string

  @ManyToOne(() => Projeto, (projeto) => projeto.arquivos)
  @JoinColumn({name:"projeto_id"})
  projeto?: Projeto

  @ManyToOne(() => Especime, (especime) => especime.arquivos)
  @JoinColumn({name:"especime_id"})
  especime?: Especime

  url: string

}
